(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-lfp-accordions] details').forEach(function (details) {
      if (details.dataset.lfpReady) return;
      details.dataset.lfpReady = '1';
      details.addEventListener('toggle', function () {
        details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
      });
    });
    scope.querySelectorAll('[data-lfp-gallery]').forEach(function (gallery) {
      if (gallery.dataset.lfpReady) return;
      gallery.dataset.lfpReady = '1';
      var rail = gallery.querySelector('[data-lfp-gallery-rail]');
      function move(direction) {
        var slides = Array.from(rail.children);
        var nearest = slides.reduce(function (best, slide, index) {
          return Math.abs(slide.offsetLeft - rail.offsetLeft - rail.scrollLeft) < best.distance ? {index:index,distance:Math.abs(slide.offsetLeft - rail.offsetLeft - rail.scrollLeft)} : best;
        }, {index:0,distance:Infinity}).index;
        var next = Math.max(0, Math.min(slides.length - 1, nearest + direction));
        rail.scrollTo({left:slides[next].offsetLeft - rail.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      gallery.querySelector('[data-lfp-gallery-prev]').addEventListener('click', function () { move(-1); });
      gallery.querySelector('[data-lfp-gallery-next]').addEventListener('click', function () { move(1); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
